module.exports = __webpack_public_path__ + "media/dummy_video.dca0a37d.mp4";